import {
  CREATE_ASAL_MAKANAN_SUCCESS,
  CREATE_ASAL_MAKANAN_FAIL,
  RETRIEVE_ASAL_MAKANAN_SUCCESS,
  RETRIEVE_ASAL_MAKANAN_FAIL,
  UPDATE_ASAL_MAKANAN_SUCCESS,
  UPDATE_ASAL_MAKANAN_FAIL,
  DELETE_ASAL_MAKANAN_SUCCESS,
  DELETE_ASAL_MAKANAN_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_ASAL_MAKANAN_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_ASAL_MAKANAN_SUCCESS:
      return payload;

    case RETRIEVE_ASAL_MAKANAN_FAIL:
      return [...datas];

    case UPDATE_ASAL_MAKANAN_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_ASAL_MAKANAN_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
